import { PaginationOutDto, PaginationInDto } from "../../../types/pagination";
interface Subscriber {
  subscriber_id: number;
  country: string;
  name: string | null;
  last_name: string | null;
  email: string;
  total_investment: number;
  free_experiences_count: number;
  experiences_count: number;
  total_subscriptions_count: number;
  recurring_subscription: {
    id: number;
    status: string;
    started_at: number | null;
    next_billing_at: number | null;
    cancelled_at: number | null;
  };
}

export const GET_COMMUNITY_SUBSCRIBERS = "GET_COMMUNITY_SUBSCRIBERS";
export const GET_COMMUNITY_SUBSCRIBERS_SUCCESS =
  "GET_COMMUNITY_SUBSCRIBERS_SUCCESS";
export const GET_COMMUNITY_SUBSCRIBERS_ERROR =
  "GET_COMMUNITY_SUBSCRIBERS_ERROR";

export interface GetCommunitySubscribers {
  type: typeof GET_COMMUNITY_SUBSCRIBERS;
  payload: PaginationOutDto;
}

export interface GetCommunitySubscribersSuccess {
  type: typeof GET_COMMUNITY_SUBSCRIBERS_SUCCESS;
  payload: {
    data: Subscriber[];
    pagination: PaginationInDto;
  };
}

export interface GetCommunitySubscribersError {
  type: typeof GET_COMMUNITY_SUBSCRIBERS_ERROR;
  payload: boolean | string;
}

export interface State {
  data: {
    data: Subscriber[];
    pagination: PaginationInDto;
  } | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetCommunitySubscribers
  | GetCommunitySubscribersError
  | GetCommunitySubscribersSuccess;
